import { createStyles } from '@material-ui/core';

export const estilos = createStyles({
  botonExpandirPantalla: { position: 'absolute', bottom: 20, right: 20 },
  contenedorIframe: { position: 'relative' },
  contenedorIframePantallaCompleta: { position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1200 },
  estilosIframe: { height: '72vh', width: '100%' },
  estilosIframePantallaCompleta: { height: '100vh', width: '100%' },
});
